import React from 'react';
import {
  resolveTranslationsPath,
  TRANSLATIONS_SUBNAV_LIBRARY,
  TRANSLATIONS_SUBNAV_OTHERS,
  TRANSLATIONS_SUBNAV_TYPE,
} from '@go-client/routes';
import { Property } from '@go-shared/types/property';
import { camelToSentenceCase } from '@go-shared/lib/string';
import { BubbleNavigation } from '../BubbleUI';

interface TranslationsSubNavigationProps {
  active: TRANSLATIONS_SUBNAV_TYPE;
  property: Property;
}

export default function TranslationsSubNavigation(props: TranslationsSubNavigationProps) {
  const navItems = TRANSLATIONS_SUBNAV_LIBRARY.includes(props.active)
    ? TRANSLATIONS_SUBNAV_LIBRARY
    : TRANSLATIONS_SUBNAV_OTHERS.includes(props.active)
      ? TRANSLATIONS_SUBNAV_OTHERS
      : [];

  return (
    <BubbleNavigation
      appearance="squared"
      items={navItems.map(ni => ({
        name: camelToSentenceCase(ni),
        to: resolveTranslationsPath(props.property._id, ni),
        active: props.active === ni,
        variant: 'titanium',
      }))}
    />
  );
}
